import $ from 'jquery';

function onClick() {
    const hash = $(this).attr('data-target');
    if (hash.includes('#')) {
        window.location.replace(hash);
    }
}

export function init(namespace = 'collapse'){
    if (window.location.hash.includes(namespace)) {
        $(`[data-target="${window.location.hash}"]`).trigger('click');
    }

    $('[data-toggle="collapse"]').on('click', onClick);
}

export default {
    init
};
